module.exports = __webpack_public_path__ + "static/media/Group 29179.62ed6dd0.png";